import script from "./home-v2-jobs-app.vue?vue&type=script&setup=true&lang=js"
export * from "./home-v2-jobs-app.vue?vue&type=script&setup=true&lang=js"

import "./home-v2-jobs-app.vue?vue&type=style&index=0&id=65b95f59&lang=scss&scoped=true"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65b95f59"]])

export default __exports__